<template>
    <el-dialog :visible.sync="popupModal" width="700px" :title="$t('operation.task.channelPreview')">
        <template>
            <div class="sys-div">
                <div class="tool-box" v-if="[0, 2].includes(actionType)">
                    <img src="../../../../assets/icon/refresh-1.png" style="margin-right:20px;" @click="refreshImg" />
                    <template v-if="!loadChannelImgFail">
                        <div class="tool-drawing-div" v-if="isDrawing">
                            <img src="../../../../assets/icon/draw-2.png" />
                        </div>
                        <img src="../../../../assets/icon/draw-1.png" v-else style="margin-right:20px;"
                            @click="startDraw" />
                        <img src="../../../../assets/icon/clear-1.png" :disabled="isDrawing" @click="clearAll" />
                    </template>
                </div>
                <div class="canvas-wrap" v-if="!loadChannelImgFail">
                    <canvas id="imgCanvas" ref="canvaxbox"></canvas>
                    <canvas id="drawCanvas" ref="canvas" :style="{ cursor: isDrawing ? 'crosshair' : 'default' }">
                    </canvas>
                    <canvas id="saveCanvas" ref="canvasSave"></canvas>
                </div>
                <div v-if="loadChannelImgFail"
                    style="width: 640px; height: 360px; line-height: 360px;background:#eee;text-align:center;">
                    <img src="../../../../assets/icon/no-pic.svg"
                        style="width: 182px;height: 156px;vertical-align: middle;" />
                </div>
            </div>
            <ChannelScheduleAdd ref="channelScheduleAddRef" v-if="[0, 2].includes(actionType)"></ChannelScheduleAdd>
            <ChannelScheduleDetail ref="channelScheduleDetailRef" v-else></ChannelScheduleDetail>
            <span slot="footer" class="dialog-footer" v-if="[0, 2].includes(actionType)">
                <el-button @click="popupModal = false" class="sys-btn-default">{{ $t('common.cancel') }}</el-button>
                <el-button @click="saveData" v-if="!loadChannelImgFail" type="primary">{{ $t('common.confirm')
                    }}</el-button>
            </span>
        </template>
    </el-dialog>

</template>

<script>
import ChannelScheduleAdd from './channelScheduleAdd.vue'
import ChannelScheduleDetail from './channelScheduleDetail.vue'
import Cookies from "js-cookie";
export default {
    components: { ChannelScheduleAdd, ChannelScheduleDetail },
    data() {
        return {
            popupModal: false,
            actionType: 0, // 0:add 1:detail 2:update
            monitorId: Number(Cookies.get("monitorId")),
            loadChannelImgFail: true,
            imgUrl: null,
            isDrawing: false,
            ratio: 1,
            imgWidth: null,
            imgHeight: null,
            wrapWidth: 300,
            wrapHeight: 300,
            canvasWidth: 300,
            canvasHeight: 300,
            drawingPoints: [],
            drawedPoints: [],
            imgCanvas: null,
            imgCtx: null,
            drawCanvas: null,
            drawCtx: null,
            saveCanvas: null,
            saveCtx: null,
            submitData: [],
            filterRegion: [],
        }
    },
    mounted() {

    },
    methods: {
        close() {
            this.popupModal = false;
        },
        refreshImg() {
            this.isDrawing = false;
            this.drawingPoints = [];
            this.getImage();
        },
        open(type, cameraNo, data) {
            this.drawingPoints = [];
            this.isDrawing = false;
            this.actionType = type;
            this.submitData = [];
            this.submitData.push(data.pointer);
            this.popupModal = true;
            this.imgUrl = window.baseURL + this.$Api.imageGetChannleImage + "/" + this.monitorId + "/" + cameraNo;
            this.$nextTick(() => {
                this.initCanvas()
                this.getImage()
                if ([0, 2].includes(type)) {
                    this.$refs.channelScheduleAddRef.open(type, data.formData);
                } else {
                    this.$refs.channelScheduleDetailRef.open(data.formData);
                }
            })
        },
        saveData() {
            this.savePoints();
            let data = this.$refs.channelScheduleAddRef.saveData();
            let filterScale = [], flag = false;
            data.forEach(item => {
                if (item.timePeriods == '' || item.timePeriods == null || item.timePeriods.length === 0) {
                    flag = true;
                } else {
                    let obj = { beginTime: item.timePeriods[0], endTime: item.timePeriods[1] }
                    if (item.scale) {
                        obj.scale = item.scale
                    }
                    filterScale.push(obj);
                }
            });
            if (flag) {
                this.$message.error(this.$t('operation.task.scheduleEmpty'));
                return false;
            }
            this.$emit('saveChannelData', { filterRegion: this.filterRegion, filterScale });
        },

        initCanvas() {
            let canvasWrap = document.getElementsByClassName('canvas-wrap')
            if (canvasWrap && canvasWrap.length > 0) {
                this.wrapWidth = canvasWrap[0].clientWidth
                this.wrapHeight = canvasWrap[0].clientHeight

                this.imgCanvas = document.getElementById('imgCanvas')
                this.imgCtx = imgCanvas.getContext('2d')

                this.drawCanvas = document.getElementById('drawCanvas')
                this.drawCtx = drawCanvas.getContext('2d')


                this.saveCanvas = document.getElementById('saveCanvas')
                this.saveCtx = saveCanvas.getContext('2d')
            }
        },
        initImgCanvas() {
            let ww = this.wrapWidth
            let wh = this.wrapHeight
            let iw = this.imgWidth
            let ih = this.imgHeight

            if (iw / ih < ww / wh) {
                this.ratio = ih / wh
                this.canvasHeight = wh
                this.canvasWidth = wh * iw / ih
            } else {
                this.ratio = iw / ww
                this.canvasWidth = ww
                this.canvasHeight = ww * ih / iw
            }
            imgCanvas.width = this.canvasWidth
            imgCanvas.height = this.canvasHeight
            drawCanvas.width = this.canvasWidth
            drawCanvas.height = this.canvasHeight
            saveCanvas.width = this.canvasWidth
            saveCanvas.height = this.canvasHeight

            let img = document.createElement('img')
            img.src = this.imgUrl;
            img.crossorigin = "anonymous";
            img.onload = () => {
                this.imgCtx.drawImage(img, 0, 0, this.canvasWidth, this.canvasHeight)
                this.renderDatas()
            }
        },
        startDraw() {
            if (this.isDrawing) return
            this.clearAll();
            this.isDrawing = true

            drawCanvas.addEventListener("click", this.drawImageClickFn)
            drawCanvas.addEventListener("dblclick", this.drawImageDblClickFn)
            drawCanvas.addEventListener("mousemove", this.drawImageMoveFn)
        },
        clearAll() {
            this.saveCtx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
            this.drawedPoints = []
        },
        getImage() {
            let img = new Image();
            img.src = this.imgUrl;
            img.onload = () => {
                this.loadChannelImgFail = false;
                this.imgWidth = img.width;
                this.imgHeight = img.height;
                this.$nextTick(() => {
                    this.initCanvas();
                    this.initImgCanvas();
                })
            }
            img.onerror = () => {
                this.loadChannelImgFail = true;
            }
        },
        drawImageClickFn(e) {
            if (e.offsetX || e.layerX) {
                let pointX = e.offsetX == undefined ? e.layerX : e.offsetX;
                let pointY = e.offsetY == undefined ? e.layerY : e.offsetY;
                let lastPoint = this.drawingPoints[this.drawingPoints.length - 1] || []
                if (lastPoint[0] !== pointX || lastPoint[1] !== pointY) {
                    this.drawingPoints.push([pointX, pointY])
                }
            }
        },
        drawImageMoveFn(e) {
            let drawCtx = this.drawCtx
            if (e.offsetX || e.layerX) {
                let pointX = e.offsetX == undefined ? e.layerX : e.offsetX;
                let pointY = e.offsetY == undefined ? e.layerY : e.offsetY;
                drawCtx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);

                drawCtx.fillStyle = '#FF3939'
                this.drawingPoints.forEach((item, i) => {
                    drawCtx.beginPath();
                    drawCtx.arc(...item, 6, 0, 180)
                    drawCtx.fill();
                })

                drawCtx.save()
                drawCtx.beginPath();
                this.drawingPoints.forEach((item, i) => {
                    drawCtx.lineTo(...item)
                })
                drawCtx.lineTo(pointX, pointY)
                drawCtx.lineWidth = "2";
                drawCtx.setLineDash([5, 6]);
                drawCtx.strokeStyle = "#FF3939";
                drawCtx.fillStyle = 'rgba(0, 0, 0, 0)'
                drawCtx.stroke();
                drawCtx.fill();
                drawCtx.restore()
            }
        },
        drawImageDblClickFn(e) {
            let drawCtx = this.drawCtx
            if (e.offsetX || e.layerX) {
                let pointX = e.offsetX == undefined ? e.layerX : e.offsetX;
                let pointY = e.offsetY == undefined ? e.layerY : e.offsetY;
                let lastPoint = this.drawingPoints[this.drawingPoints.length - 1] || []
                if (lastPoint[0] !== pointX || lastPoint[1] !== pointY) {
                    this.drawingPoints.push([pointX, pointY])
                }
            }
            drawCtx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
            this.drawSaveArea(this.drawingPoints)

            this.drawedPoints.push(this.drawingPoints)
            this.drawingPoints = []
            this.isDrawing = false

            drawCanvas.removeEventListener("click", this.drawImageClickFn)
            drawCanvas.removeEventListener("dblclick", this.drawImageDblClickFn)
            drawCanvas.removeEventListener("mousemove", this.drawImageMoveFn)
        },
        drawSaveArea(points) {
            if (!points instanceof Array || points.length === 0) return
            this.saveCtx.save()
            this.saveCtx.beginPath();
            points.forEach((item, i) => {
                this.saveCtx.lineTo(...item)
            })
            this.saveCtx.closePath()
            this.saveCtx.setLineDash([5, 6]);
            this.saveCtx.lineWidth = "2";
            this.saveCtx.fillStyle = 'rgba(0, 0, 0, 0)'
            this.saveCtx.strokeStyle = "#FF3939";
            this.saveCtx.stroke();
            this.saveCtx.fill();
            this.saveCtx.restore()
        },
        savePoints() {
            let objectPoints = [];
            let region = [];
            objectPoints = this.drawedPoints.map(area => {
                let polygon = {}
                area.forEach((point, i) => {
                    let positionX = point[0] * this.ratio;
                    let positionY = point[1] * this.ratio;
                    polygon[`x${i + 1}`] = Math.round(positionX)
                    polygon[`y${i + 1}`] = Math.round(positionY)
                    let x = Math.round(10000 * positionX / this.imgWidth)
                    let y = Math.round(10000 * positionY / this.imgHeight)
                    region.push({ x, y });
                });
                return {
                    "polygon": polygon
                }
            });
            this.filterRegion = region;
            this.submitData = objectPoints
        },
        renderDatas() {
            this.drawedPoints = this.submitData.map(item => {
                let polygon = item.polygon
                let points = []
                for (let i = 1; i < Object.keys(polygon).length / 2 + 1; i++) {
                    if (!isNaN(polygon[`x${i}`]) && !isNaN(polygon[`y${i}`])) {
                        let positionX = Math.round(polygon[`x${i}`] * this.imgWidth / 10000 / this.ratio);
                        let positionY = Math.round(polygon[`y${i}`] * this.imgHeight / 10000 / this.ratio);
                        points.push([positionX, positionY])
                    }
                }
                this.drawSaveArea(points)
                return points
            })
        }
    }
}
</script>

<style scoped>
.sys-div {
    position: relative;
    margin: 0 auto 20px auto;
    width: 640px;
    text-align: center;
}

.tool-box {
    width: 640px;
    padding: 0 0 10px;
    box-sizing: border-box;
    text-align: right;
    height: 40px;
    line-height: 40px;
}

.tool-box img {
    width: 21px;
    height: 21px;
    cursor: pointer;
}

.tool-drawing-div {
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 2px;
    margin-right: 20px;
    background: #0B73F6;
}

.canvas-wrap {
    width: 640px;
    height: 360px;
    margin: 0px auto;
    /* background-color: #000; */
    border: 3px;
    /* border-color: #333; */
    position: relative;
}

#imgCanvas,
#drawCanvas,
#saveCanvas {
    background: rgba(255, 0, 255, 0);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

#drawCanvas {
    z-index: 2;
}
</style>